(function () {
  function initNfcBusinessCards(root) {
    root = root || document;

  // Reveal animation + comparison rows
  var els = root.querySelectorAll('[data-reveal], .cmp-r-ogc');

  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) {
      el.classList.add('is-visible');
    });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var el = entry.target;

        // Stagger the One Good Card comparison rows
        if (el.classList.contains('cmp-r-ogc')) {
          var rows = Array.prototype.slice.call(
            root.querySelectorAll('.cmp-r-ogc')
          );

          var index = rows.indexOf(el);
          var check = el.querySelector('.cmp-mark-check');
          var text = el.querySelector('p');

          if (check) {
            check.style.animationDelay = (index * 120) + 'ms';
          }

          if (text) {
            text.style.animationDelay = (index * 120 + 120) + 'ms';
          }
        }

        el.classList.add('is-visible');
        io.unobserve(el);
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  // Testimonial + Case Study carousel
  root.querySelectorAll('.testimonial-carousel').forEach(function (testimonialCarousel) {
    var testimonialTrack = testimonialCarousel.querySelector('.testimonial-scroll');
    var testimonialPrev = testimonialCarousel.querySelector('.tcard-nav.prev');
    var testimonialNext = testimonialCarousel.querySelector('.tcard-nav.next');

    if (testimonialTrack && testimonialPrev && testimonialNext && !testimonialCarousel.dataset.initialized) {
      testimonialCarousel.dataset.initialized = 'true';

      function testimonialScrollAmount() {
        var card = testimonialTrack.firstElementChild;
        var gap = 20;
        return card ? card.offsetWidth + gap : testimonialTrack.clientWidth * 0.8;
      }

      function updateTestimonialButtons() {
        var maxScroll = testimonialTrack.scrollWidth - testimonialTrack.clientWidth - 1;

        testimonialPrev.disabled = testimonialTrack.scrollLeft <= 0;
        testimonialNext.disabled = testimonialTrack.scrollLeft >= maxScroll;
      }

      testimonialPrev.addEventListener('click', function () {
        testimonialTrack.scrollBy({
          left: -testimonialScrollAmount(),
          behavior: 'smooth'
        });
      });

      testimonialNext.addEventListener('click', function () {
        testimonialTrack.scrollBy({
          left: testimonialScrollAmount(),
          behavior: 'smooth'
        });
      });

      testimonialTrack.addEventListener('scroll', updateTestimonialButtons, { passive: true });
      window.addEventListener('resize', updateTestimonialButtons);

      requestAnimationFrame(updateTestimonialButtons);

var raf;
var speed = 0.35;

function drift() {
  if (window.innerWidth <= 990) return;

  var max = testimonialTrack.scrollWidth - testimonialTrack.clientWidth;

  testimonialTrack.scrollLeft += speed;

  if (testimonialTrack.scrollLeft >= max) {
    testimonialTrack.scrollLeft = 0;
  }

  raf = requestAnimationFrame(drift);
}

function startDrift() {
  cancelAnimationFrame(raf);
  drift();
}

function stopDrift() {
  cancelAnimationFrame(raf);
}

testimonialCarousel.addEventListener('mouseenter', stopDrift);
testimonialCarousel.addEventListener('mouseleave', startDrift);

testimonialTrack.addEventListener('pointerdown', stopDrift);
testimonialTrack.addEventListener('touchstart', stopDrift, { passive: true });

window.addEventListener('resize', function () {
  if (window.innerWidth > 990) startDrift();
  else stopDrift();
});

startDrift();
    }
  });

    // Video carousel navigation
    var videoCarousel = root.querySelector('.video-carousel');
    if (videoCarousel) {
      var videoTrack = videoCarousel.querySelector('.video-row');
      var videoPrev = videoCarousel.querySelector('.vcard-nav.prev');
      var videoNext = videoCarousel.querySelector('.vcard-nav.next');

      if (videoTrack && videoPrev && videoNext && !videoCarousel.dataset.initialized) {
        videoCarousel.dataset.initialized = 'true';

        function videoScrollAmount() {
          var item = videoTrack.querySelector('.video-item');
          var gap = 24;
          return item ? item.offsetWidth + gap : videoTrack.clientWidth * 0.8;
        }

        function updateVideoButtons() {
          var maxScroll = videoTrack.scrollWidth - videoTrack.clientWidth - 1;
          videoPrev.disabled = videoTrack.scrollLeft <= 0;
          videoNext.disabled = videoTrack.scrollLeft >= maxScroll;
        }

        videoPrev.addEventListener('click', function () {
          videoTrack.scrollBy({ left: -videoScrollAmount(), behavior: 'smooth' });
        });

        videoNext.addEventListener('click', function () {
          videoTrack.scrollBy({ left: videoScrollAmount(), behavior: 'smooth' });
        });

        videoTrack.addEventListener('scroll', updateVideoButtons, { passive: true });
        window.addEventListener('resize', updateVideoButtons);
        window.addEventListener('load', updateVideoButtons);
        requestAnimationFrame(updateVideoButtons);
        updateVideoButtons();
      }
    }

    // YouTube click-to-play
    root.querySelectorAll('.video-card[data-yt]').forEach(function (card) {
      if (card.dataset.videoInitialized) return;
      card.dataset.videoInitialized = 'true';

      card.addEventListener('click', function () {
        var id = card.getAttribute('data-yt');
        if (!id) return;

        var wrapper = document.createElement('div');
        wrapper.className = 'video-card is-playing';
        wrapper.innerHTML =
          '<iframe ' +
          'src="https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1" ' +
          'title="One Good Card video" ' +
          'frameborder="0" ' +
          'allow="autoplay; encrypted-media; picture-in-picture; web-share" ' +
          'allowfullscreen>' +
          '</iframe>';

        card.replaceWith(wrapper);
      });
    });

    // Lucide icons
    if (window.lucide) {
      window.lucide.createIcons();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initNfcBusinessCards(document);
    });
  } else {
    initNfcBusinessCards(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initNfcBusinessCards(event.target);
  });
})();